import React from "react";

import { MAPPED_UNASSESSED_DOT_COLOR } from "./relationshipUtils";

const MATRIX_HINT =
  "Click an unmapped cell to map · Click a mapped cell to assess · Switch RL, Goals, or Posture in the toolbar";

function RlMatrixLegend() {
  return (
    <>
      <div className="ml-item">
        <div className="ml-dot" style={{ background: "#22c55e" }} />
        Strong (RL 4–5)
      </div>
      <div className="ml-item">
        <div className="ml-dot" style={{ background: "#eab308" }} />
        Moderate (RL 2–3)
      </div>
      <div className="ml-item">
        <div className="ml-dot" style={{ background: "#ef4444" }} />
        Poor (RL 0–1)
      </div>
      <div className="ml-item">
        <div
          className="ml-dot"
          style={{ background: MAPPED_UNASSESSED_DOT_COLOR }}
        />
        Mapped · to assess
      </div>
      <div className="ml-item">
        <div className="ml-tile ml-tile--unmapped" />
        Unmapped
      </div>
    </>
  );
}

function PostureMatrixLegend() {
  return (
    <>
      <div className="ml-item">
        <span className="pcell-badge matrix-legend-badge" aria-hidden>
          A
        </span>
        Advocate
      </div>
      <div className="ml-item">
        <span className="pcell-badge matrix-legend-badge" aria-hidden>
          N
        </span>
        Neutral
      </div>
      <div className="ml-item">
        <span className="pcell-badge matrix-legend-badge" aria-hidden>
          D
        </span>
        Detractor
      </div>
      <div className="ml-item">
        <span className="pcell-badge matrix-legend-badge pu" aria-hidden>
          U
        </span>
        Unknown
      </div>
    </>
  );
}

/** Legend bar for Relationships Matrix — RL/Goals share RL bands; Posture uses letter badges. */
export function MatrixModeLegend({ cellMode = "rl" }) {
  const isPosture = cellMode === "posture";

  return (
    <div className="matrix-legend">
      {isPosture ? <PostureMatrixLegend /> : <RlMatrixLegend />}
      <div className="ml-item">
        <div className="ml-tile ml-tile--highlighted" />
        Assessed this visit
      </div>
      <span className="matrix-legend-hint">{MATRIX_HINT}</span>
    </div>
  );
}

export default MatrixModeLegend;
